import $ from 'jquery'

import '../../../scss/app/seasonal_reconnect_form.scss'

//
// Customer Type
//

const $customerType = $('input[name="seasonal_reconnect[customerType]"]')
const $ifResidential = $('.if-residential')
const $ifBusiness = $('.if-business')

function handleCustomerType() {
  $ifResidential[$customerType.filter(':checked').val() === 'Residential' ? 'show' : 'hide']()
  $ifBusiness[$customerType.filter(':checked').val() === 'Business' ? 'show' : 'hide']()
}

handleCustomerType()
$customerType.on('click', handleCustomerType)

//
// Address Change
//

const $addressChange = $('input[name="seasonal_reconnect[addressChange]"]')
const $ifAddressChange = $('.js-if-address-change')

function handleAddressChange() {
  if ($addressChange.filter(':checked').val() === '1') {
    $ifAddressChange.show()
  } else {
    $ifAddressChange.hide()
  }
}

handleAddressChange()
$addressChange.on('click', handleAddressChange)

//
// Paperless Billing
//

const $paperlessBilling = $('input[name="seasonal_reconnect[paperlessBilling]"]')
const $ifPaperlessBilling = $('.if-paperless-billing')

function handlePaperlessBilling() {
  $ifPaperlessBilling[$paperlessBilling.filter(':checked').val() == 1 ? 'show' : 'hide']()
}

handlePaperlessBilling()
$paperlessBilling.on('click', handlePaperlessBilling)

//
// Conditional items
//

const $ifReconnectPhone = $('.if-reconnect-telephone')
const $ifReconnectInternet = $('.if-reconnect-internet')
const $ifReconnectTv = $('.if-reconnect-tv')
const $reconnect = $('input[name="seasonal_reconnect[services][]"]')

function handleReconnect() {
  $ifReconnectPhone.hide()
  $ifReconnectInternet.hide()
  $ifReconnectTv.hide()

  $reconnect.filter(':checked').each((_, checkbox) => {
    const $checkbox = $(checkbox)
    const val = $checkbox.val()

    if (val === 'Telephone') {
      $ifReconnectPhone.show()
    } else if (val === 'Internet') {
      $ifReconnectInternet.show()
    } else if (val === 'TV') {
      $ifReconnectTv.show()
    }
  })
}

handleReconnect()
$reconnect.on('click', handleReconnect)

//
// SkyChange
//

const skyChangeOptions = document.querySelectorAll('.skychange-option')

function handleSkyChangeOptions() {
  skyChangeOptions.forEach((option) => {
    const input = option.querySelector('input')
    if (input.checked) {
      option.classList.add('selected')
    } else {
      option.classList.remove('selected')
    }
  })
}

handleSkyChangeOptions()

skyChangeOptions.forEach((option) => {
  option.addEventListener('click', () => {
    const input = option.querySelector('input')
    input.checked = true
    handleSkyChangeOptions()
  })
})
